import { Http } from 'dashboard-js/forms/Http'
// import { _ } from 'underscore'
import { redirect } from 'dashboard-js/helpers'
// import {sendForm} from "dashboard-js/forms/http-extends";

/**
 * Add additional HTTP / form helpers to the Spark object.
 */
// $.extend(Spark, require('spark-js/forms/http'));
$.extend(Spark, {
    delete: Http.delete,
    patch: Http.patch,
    post: Http.post,
    put: Http.put,
    sendForm: Http.sendForm,
    sendFormData: Http.sendFormData,

    redirect: redirect,
})

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': Spark.csrfToken,
}

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
window.axios.interceptors.response.use(
    function(response) {
        return response
    },
    function(error) {
        switch (error.response.status) {
            case 401:
                window.location.reload()
                // window.axios.get(route('logout'));
                // $('#modal-session-expired').modal('show');
                break

            case 402:
                // window.location = '/dashboard/settings#/subscription';
                break
        }

        return Promise.reject(error)
    }
)
